import { useTranslation } from "react-i18next";
import notSupported from "@Assets/images/notSupported.svg";
import css from "./index.module.css";

export default function OldBrowserWarning() {
  const { t } = useTranslation();
  return (
    // css module is used because tailwind is not running in older browsers
    <div className={css.root}>
      <img src={notSupported} />
      <p>{t("Please update your browser")}</p>
    </div>
  );
}
